"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const _excluded = ["type", "elementClass", "children", "datatestid"];
/*
* SVB Text Block
* <SVBTextBlock type="block-nospace">{children}</SVBTextBlock>
*/
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * SVBTextBlock
 * @param type:  defines the type of text block
 * @param elementClass: defines additional class
 * @param children: node(child component(s)) 
 * @param datatestid: defines test id passed for unit tests
 * @returns HTML tag with content
 */

const SVBTextBlock = _ref => {
  let {
      type,
      elementClass,
      children,
      datatestid
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const finalClass = "svb-text-block ".concat(type ? type : 'block-default', " ").concat(elementClass ? elementClass : 'default');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: finalClass,
    "data-testid": datatestid ? datatestid : null
  }, children);
};
var _default = SVBTextBlock;
exports.default = _default;